import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { DomainGroupService, Rule } from '@client/app/services/entities/domain-group/domain-group.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';

@Component({
    selector: 'form-domain-groups-create',
    templateUrl: '../_form.html',
    standalone: false,
})
export class FormDomainGroupsCreateComponent implements OnInit, AfterViewInit {
    @Input() domain;
    @Input() monDialogId;
    @Input() setForm?: (params: any) => void;

    saving = false;
    domainGroup: { title?: string; rules: Rule[] } = { rules: [] };
    title;
    groupForm;

    get isDomainGroupComplete (): boolean {
        return this.domainGroupService.isDomainGroupComplete(this.domainGroup);
    }

    constructor (
        private domainGroupService: DomainGroupService,
        private translateService: TranslateService,
        private monDialog: MonDialog,
    ) {}

    ngOnInit () {
        this.saving = false;
        this.domainGroup = { rules: [] };
        this.title = this.translateService.getString('Create new domain group');
    }

    ngAfterViewInit (): void {
        this.setForm?.({ id: this.monDialogId, form: this.groupForm });
    }

    close (data) {
        if (this.groupForm) {
            this.groupForm.$setPristine();
        }
        this.monDialog.close(this.monDialogId, data || this.domainGroup);
    }

    save () {
        this.saving = true;
        this.domainGroup.rules = this.domainGroupService.cleanupRules(this.domainGroup.rules) as Rule[];
        this.domainGroupService
            .create(this.domain, this.domainGroup)
            .then((data) => {
                this.close(data);
            }, () => {})
            .finally(() => {
                this.saving = false;
            });
    }
}
